export const loadImage = (url, context, callback) => {
  if(!url && context) {
    context.setState({
      imageSrc: null
    })
    return
  }
  const image = new Image()
  image.onload = () => {
    if(context) {
      context.setState({
        imageSrc: url
      }, () => {
        if(typeof callback === 'function') callback(image)
      })
    }
  }
  image.src = url
}


// WEBPACK FOOTER //
// ./src/services/service-image-loader.js